import { Fragment, useEffect } from "react";
import { useParams } from "react-router";
import { rootUrl } from "../../../../config/setting";
import classes from "./BlogPost.module.css";
import "./BlogPost.css";
import BlogCardList from "components/Blog/BlogCard/BlogCardList";
import WaitingFor from "components/Banner/WaitingFor";
import { useSelector } from "react-redux";
import BackgroundItems from "../../../BackGround/BackgroundItems";
import SNSbox from "components/Blog/BlogPost/SNSbox";
import BlogPostContent from "components/Blog/BlogPost/BlogPostContent";

const Index = (props) => {
  const lan = useSelector((state) => state?.settings?.lan ?? "en");
  const params = useParams();
  const tagId = props.tagIds[lan];

  // setup blog post
  let blogPost = props.blogPost ? props.blogPost[lan] : null;
  let otherBlogPosts = props.otherBlogPostList
    ? props.otherBlogPostList[lan]
    : null;
  const { getBlogPost, getOtherBlogPostList } = props;

  // setup UI data for SNS
  const postUrl = rootUrl + `/blogs/${params.id}/`;

  useEffect(() => {
    getOtherBlogPostList(lan, params.id, tagId);
    getBlogPost(lan, params.id, tagId);
  }, [lan, tagId]);

  return (
    <Fragment>
      <section className={classes["blog-post-section"]}>
        <BackgroundItems />
        <div className={classes["content-wrapper"]}>
          <BlogPostContent blogPost={blogPost} />
          <SNSbox blogPost={blogPost} postUrl={postUrl} />
        </div>
      </section>
      <section className={classes["blog-card-section"]}>
        <h2 className={classes["blog-card-heading"]}>
          Other articles you may be interested in
        </h2>
        <BlogCardList blogList={otherBlogPosts} />
      </section>
      <WaitingFor />
    </Fragment>
  );
};

export default Index;
